import * as React from 'react';
import cn from 'classnames';
import { RadioButtonGroup, UiKitContextProvider } from '@cian/ui-kit';
import { ErrorPopover } from '../../../ErrorPopover';
import * as styles from './styles.css';
import { sortRoomsCount } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function RoomsCountSelector(props) {
  var errorMessage = props.errorMessage,
      value = props.value,
      className = props.className,
      onValueChange = props.onValueChange,
      values = props.values;
  var valuesList = React.useMemo(function () {
    return sortRoomsCount(Object.values(values));
  }, [values]);
  return /*#__PURE__*/_jsx(UiKitContextProvider, {
    deviceType: "phone",
    useStaticDeviceType: true,
    children: /*#__PURE__*/_jsx(ErrorPopover, {
      tooltipContent: errorMessage || '',
      children: /*#__PURE__*/_jsx("div", {
        className: cn(styles['container'], className),
        "data-name": "roomsCount_filter",
        children: /*#__PURE__*/_jsx(RadioButtonGroup, {
          value: value || undefined,
          options: valuesList,
          onChange: function onChange(_, value) {
            return onValueChange(value);
          }
        })
      })
    })
  });
}